export default __webpack_public_path__ + "static/media/new-fund-side-img-old.35743c0c.svg";